import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // No OAuth callback needed - redirect to login
    navigate("/login", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-[#2E3A59] border-t-transparent rounded-full animate-spin"></div>
        <p className="text-[#2E3A59] font-medium">Redirecting...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
